import styled from 'styled-components';
import {Text} from '@forecast-it/design-system';
import {EmptyState} from './EmptyState';
import {StreamHistoryCard} from './StreamHistoryCard';
import type {StreamEntry} from './StreamHistoryCard';

interface Props {
	entries: StreamEntry[];
}

// One turn per row, with enough air between them that a long thread stays readable.
const Turns = styled.div`
	display: flex;
	flex-direction: column;
	gap: ${p => p.theme.sys.spacing[500]};
`;

export function StreamHistory({entries}: Props) {
	if (entries.length === 0) {
		return (
			<EmptyState inset>
				<Text color="auxiliary">No messages yet. Start the conversation below.</Text>
			</EmptyState>
		);
	}

	return (
		<Turns data-testid="stream-history">
			{entries.map(entry => (
				<StreamHistoryCard key={entry.id} entry={entry} />
			))}
		</Turns>
	);
}
